import { Component, h } from "@stencil/core";
// the file is imported as string (plain text), see stencil.config.ts
// that's because this javascript is not suited to be parsed during compilation, it is meant to be rendered as is
import liveEngageScriptRawContent from '../../live-engage-init.js'

/**
 * Script element to initialize the LiveEngage chat.
 * The script is rendered together with the elements to be hydrated by it, to make sure the script is executed after the elements are rendered.
 * */
@Component({
  tag: 'live-engage-init-script',
})
export class LiveEngageInitScript {
  render() {
    return <script type="text/javascript" innerHTML={liveEngageScriptRawContent}></script>
  }
}
